// extracted by mini-css-extract-plugin
export var Share = "share-module--Share--1bMhq";
export var Share__control = "share-module--Share__control--w1feW";